import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { LogEntry } from './logEntry';
import { QueueLink } from './queueLink/queueLink';
import { UserLink } from './userLink/userLink';

type ConversationAddedToQueueProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_ADDED_TO_QUEUE'>;
};

export const ConversationAddedToQueue = ({
  entry,
}: ConversationAddedToQueueProps): JSX.Element => {
  const agentLink = entry.agent_reservation_skip_reason ? (
    <UserLink userId={entry.agent_reservation_skip_reason.agent.id}>
      {entry.agent_reservation_skip_reason.agent.name ??
        entry.agent_reservation_skip_reason.agent.id}
    </UserLink>
  ) : null;

  const queueLink = (
    <QueueLink queueId={entry.queue_id}>
      {entry.queue_name || 'queue'}
    </QueueLink>
  );

  const formatAgentPreferenceType = (preferenceType: string) => {
    switch (preferenceType) {
      case 'LAST_AGENT':
        return 'last agent';
      case 'PREFERRED_AGENT':
        return 'preferred agent';
      default:
        return '';
    }
  };

  const skipReason = entry.agent_reservation_skip_reason ? (
    <>
      . Skipped{' '}
      {formatAgentPreferenceType(
        entry.agent_reservation_skip_reason.agent_preference_type,
      )}{' '}
      reservation because {agentLink} is{' '}
      {entry.agent_reservation_skip_reason.reason}
    </>
  ) : null;

  const text = (
    <>
      Conversation added to {queueLink}
      {skipReason}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
